import { xhr } from '@/api/config/Repository'
import AuthTokenResponseDTO from '@/services/auth/models/AuthTokenResponseDTO'
import AuthTokenRepository from '../AuthTokenRepository'
export default class AuthTokenRepositoryImpl implements AuthTokenRepository {
  async getAuthToken (code: string): Promise<AuthTokenResponseDTO> {
    const endpoint = 'auth/token'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache, no-store must-revalidate'
    }
    const reqBody = JSON.stringify({
      code: code,
      redirect_url: window.location.origin
    })
    const response = await xhr.post<string, any>(endpoint, reqBody, { headers })
    return {
      status: response.status,
      content: response.data
    }
  }

  async getRefreshToken (token: string): Promise<any> {
    const endpoint = 'auth/renewtoken'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache, no-store must-revalidate'
    }
    const reqBody = JSON.stringify({ refresh_token: token })
    const response = await xhr.post<string, any>(endpoint, reqBody, { headers })
    return {
      status: response.status,
      content: response.data
    }
  }
}
